export const cats = [
  {
    id: '6d95dae356e32a71db5ddcb42224754a02524c615c5fc35f568c2af04774e589',
    code: 'USDS',
    name: 'Stably USD',
    denom: 1000,
  },
  {
    id: 'a628c1c2c6fcb74d53746157e438e108eab5c0bb3e5c80ff9b1910b3e4832913',
    code: 'SBX',
    name: 'Spacebucks',
    denom: 1000,
  },
  {
    id: 'db1a9020d48d9d4ad22631b66ab4b9ebd3637ef7758ad38881348c5d24c38f20',
    code: 'DBX',
    name: 'dexie bucks',
    denom: 1000,
  },
  {
    id: '7108b478ac51f79b6ebf8ce40fa695e6eb6bef654a657d2694f1183deb78cc02',
    code: 'GAD',
    name: 'Green App Development',
    denom: 1000,
  },
  {
    id: '8ebf855de6eb146db5602f0456d2f0cbe750d57f821b6f91a8592ee9f1d4cf31',
    code: 'MRMT',
    name: 'Marmot Coin',
    denom: 1000,
  },
  {
    id: 'ec25b77bc54df637392d6a0f542de65f45020405d0f36ced723bff2870c378b1',
    code: 'MJO',
    name: 'MoJo•JoJo',
    denom: 1000,
  },
  {
    id: '509deafe3cd8bbfbb9ccce1d930e3d7b57b40c964fa33379b18d628175eb7a8f',
    code: 'CH21',
    name: 'Chia Holiday 2021',
    denom: 1000,
  },
  {
    id: 'ea830317f831a23b178aa653e50484568d30d2c5b34d8140e71247ead05961c7',
    code: 'CC',
    name: 'Caesar Coin',
    denom: 1000,
  },
  {
    id: '51ef89a35fa316c0f2747696b2483c9203da3155b603ea3f194640ada374907f',
    code: 'DCH',
    name: 'farmingDCH',
    denom: 1000,
  },
  {
    id: 'd5cfbfadf873554d5184ebcb9dee86e69f8b11f44a0cc4e417871c4f7fb17b9a',
    code: 'UFCG',
    name: 'UFC Genesis',
    denom: 1000,
  },
  {
    id: '0f8676bd61b83d8cc8543cf75a54bb6963ea7c9465eb2da4b84901778ad37d3f',
    code: 'XPCD',
    name: 'XCHPOOL Discount Coupon',
    denom: 1000,
  },
  {
    id: '79f6313fdb6ba66347a5bcad4af6878ac07bf5fafedeb384c3b350d913c8b6b6',
    code: 'NIOC',
    name: 'NioCoin',
    denom: 1000,
  },
  {
    id: '446f5c3532929f71fa82f1c65f7e93170dcfbf8d59baf82a81b6f8e8f85e8a5c',
    code: 'ALGOLD',
    name: 'Abandoned Land - Gold',
    denom: 1000,
  },
  {
    id: '482b49902d310c53065c3531d398d41808f1390590d566815d67040f6a32d124',
    code: 'CTK',
    name: 'Catkchi',
    denom: 1000,
  },
  {
    id: '4c4380af7d15c896d9e6266f322ac494c398803032eef56f2ab65877956d007f',
    code: 'NAME',
    name: 'Namesdao NAME',
    denom: 1000,
  },
  {
    id: '5fd27391e6385e5d4bdc5b7b2df67b2e8698e337d49b94302a3551deda565e58',
    code: 'POTT',
    name: 'Proof Of Treasure Coin',
    denom: 1000,
  },
  {
    id: '9995f30b83e7d3f3ea0eec7e450dbcade83f76516da79daa9a84a9daafec2329',
    code: 'ALWORK',
    name: 'Abandoned Land - Work',
    denom: 1000,
  },
  {
    id: '9995f30b83e7d3f3ea0eec7e450dbcade83f76516da79daa9a84a9daafec2329',
    code: 'ALWORK',
    name: 'Abandoned Land - Work',
    denom: 1000,
  },
  {
    id: 'ce9dfce94a5a65c0207bf3d57b407db559e9cd34f2050f8bd61291b42bead361',
    code: 'ALFOOD',
    name: 'Abandoned Land - Food',
    denom: 1000,
  },
  {
    id: '7d176bff0ac2e15fe6e5f57352e7c3a467b476a798dd38f30e39af7ef6cc52b4',
    code: 'ALORE',
    name: 'Abandoned Land - Ore',
    denom: 1000,
  },
  {
    id: '593c68c3f0c2061ea384ff30d9f3bef15039c6d5fbd46b555c73b2e9b490fca5',
    code: 'ALTOOL',
    name: 'Abandoned Land - Tool',
    denom: 1000,
  },
  {
    id: '3c75c138fe2fc94c0bae3467e7ae5a457758cb058925424ec2eb327f6b231a18',
    code: 'ALWEAP',
    name: 'Abandoned Land - Weapon',
    denom: 1000,
  },
  {
    id: '6daab7bb79093ef60f3b83dc3d9def25e91eae55916da8bf95268eda9ee871ea',
    code: 'ALWOOD',
    name: 'Abandoned Land - Wood',
    denom: 1000,
  },
];